import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Materials } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Materials.Pages.MATERIALS}/:id(\\d+)?`,
    name: Materials.Pages.MATERIALS,
    component: () => import(/* webpackChunkName: "materials" */ './views/MaterialsPage.vue'),
    meta: {
      access_roles: RouteRoles[Materials.Pages.MATERIALS],
    },
  },
];

export default routes;
